import React from 'react';
import ResourceAccordion from './ResourceAccordion';
import ResourceItem from './ResourceItem';
import TimeIndicators from './TimeIndicators';
import getResources from '../../mock/api/resources';
const ResourceAccordionExample = () => {
    const resources = getResources();
    return (React.createElement(ResourceAccordion, { title: "Selected Resources" },
        resources.map((resource) => (React.createElement(ResourceItem, { key: resource.id, name: resource.name, capacity: resource.capacity, features: resource.features, timeSlots: resource.timeSlots, status: resource.status, isSelected: true }))),
        React.createElement(TimeIndicators, { date: new Date('2023-10-28') })));
};
export default ResourceAccordionExample;
